import { render, staticRenderFns } from "./DeleteBuroDialog.vue?vue&type=template&id=4bf9cb0a"
import script from "./DeleteBuroDialog.vue?vue&type=script&lang=ts"
export * from "./DeleteBuroDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports